module.exports = __webpack_public_path__ + "static/biwee-pc-bleu-1200-cc87f66790afc8ccd8686cc704806ebe.png";